import { render, staticRenderFns } from "./RouteManager.vue?vue&type=template&id=0db6b1bc"
import script from "./RouteManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./RouteManager.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports